import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import DeskClock from '../views/DeskClock.vue'
import Everyfile from '../views/Everyfile.vue'
import Compress from '../views/Compress.vue'
import VideoConverter from '../views/VideoConverter.vue'
import FateStar from '../views/FateStar.vue'
import Longshot from '../views/Longshot.vue'
import GifMaker from '../views/GifMaker.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product/deskclock',
    name: 'DeskClock',
    component: DeskClock
  },
  {
    path: '/product/everyfile',
    name: 'Everyfile',
    component: Everyfile
  },
  {
    path: '/product/compress',
    name: 'Compress',
    component: Compress
  },
  {
    path: '/product/video-converter',
    name: 'VideoConverter',
    component: VideoConverter
  },
  {
    path: '/product/fatestar',
    name: 'FateStar',
    component: FateStar
  },
  {
    path: '/product/longshot',
    name: 'Longshot',
    component: Longshot
  },
  {
    path: '/product/gifmaker',
    name: 'GifMaker',
    component: GifMaker
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition

    // Support anchor links like /#products
    if (to.hash) {
      return {
        el: to.hash,
        top: 96,
        behavior: 'smooth'
      }
    }

    // Default: always scroll to top on route change
    return { left: 0, top: 0 }
  }
})

export default router

